export default __webpack_public_path__ + "static/media/loading.475bc1e2.gif";